import React, {Component} from 'react';
import {Row, Col, Button, Fa} from "mdbreact";
import {Link} from "react-router-dom";
import {API_URL} from "../../config/Config";

export default class Product extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }




    render() {
        const { productObj } = this.props;

        return (
            <div className="product-list-item mb-5">
                <Row>
                    <div className="d-flex justify-content-start w-100 pl-5" style={{borderTop:"1px solid #a5a5a5"}}>
                        {productObj.specialOffer ? <div><div className="text-white  primary-color-dark product-item-lables">پیشنهاد ویژه</div></div>: ""}
                        {productObj.discountAmount !==0 ? <div><div className="text-white danger-color-dark product-item-lables">{productObj.discountAmount} ریال </div></div>: ""}

                        <div className="ml-auto p-2 text-center" >
                                <p><span className="oldPrice ng-binding">{productObj.priceOld} ریال<span className="cross-price" style={{backgroundColor: "#0092cf"}}/></span></p>
                                <p><span className="newPrice"><span className="price ng-binding">{productObj.price}</span> <span className="currancy"> ریال</span> </span></p>
                        </div>
                    </div>
                </Row>
                <Row>
                    <Col sm="12" md="4" >
                        <Link to={"/product/"+productObj.id} className="product-title">
                            <img src={API_URL+productObj.pic} alt={productObj.title} className="w-100"/>
                        </Link>
                    </Col>
                    <Col sm="12" md="8" >
                        <h2 className="mt-5"><Link to={"/product/"+productObj.id} className="product-title">{productObj.title}</Link></h2>
                        <p className="text-justify">{productObj.description}</p>


                        <Row className="mt-5">
                            <Col md="6" sm="12"/>
                            <Col md="6" sm="12" className="text-center">
                                <Button outline block color="info" className="product-add-to-cart"><Fa icon="shopping-cart" className="mr-1"/> خرید {productObj.price} ریال</Button>
                                <br/>

                                <Link to={`product/${productObj.id}`} className="product-title"><Fa icon="search" className="mr-1"/> مشاهده جزئیات </Link>

                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>


        );
    }
}




// WEBPACK FOOTER //
// ./src/components/product/Product.js